// src/components/Canvas.jsx
import React from 'react';
import BlockRenderer from './BlockRenderer';
import './Canvas.css';
import PropTypes from 'prop-types';

function Canvas({
  blocks,
  selectedBlockId,
  onSelectBlock,
  onDeleteBlock,
  onDragStart,
  onDragOver,
  onDrop,
  canvasRef,
}) {
  return (
    <div className="canvas">
      <div className="canvas-header">
        💡 Glissez les blocs de gauche ici ou réorganisez-les
      </div>
      <div
        className="canvas-wrapper"
        ref={canvasRef}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <div className="canvas-inner">
          {blocks.length === 0 ? (
            <div className="canvas-empty-state">
              <div className="canvas-empty-state-icon">🎨</div>
              <p>Glissez des blocs ici pour commencer à éditer votre page</p>
            </div>
          ) : (
            blocks.map((block) => (
              <BlockRenderer
                key={block.id}
                block={block}
                isSelected={selectedBlockId === block.id}
                onSelect={() => onSelectBlock(block.id)}
                onDelete={() => onDeleteBlock(block.id)}
                onDragStart={() => onDragStart(block.id)}
                onDrop={onDrop}
                onDragOver={onDragOver}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}

Canvas.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedBlockId: PropTypes.string,
  onSelectBlock: PropTypes.func.isRequired,
  onDeleteBlock: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragOver: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  canvasRef: PropTypes.object.isRequired,
};

export default Canvas;
